/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/structure/modal/modal_styles';



/* ========== ~~~~~~~~~~ MODAL : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Modal extends Component {
	componentDidUpdate(prevProps) {
        if (this.props.visible && this.props.currentPage !== prevProps.currentPage) { 
        	this.handleClose();
        }
        if (this.props.visible !== prevProps.visible) {
        	if (this.props.visible) {
        		document.addEventListener('mousedown', this.handleOutsideClick, false);
        	} else {
        		document.removeEventListener('mousedown', this.handleOutsideClick, false);
        	}
        }
    }
	handleClose = () => {
		this.props.displayModal(false);
	}
	handleOutsideClick = (e) => {
		// ignore clicks on the component itself
		if (this.node.contains(e.target)) { return; }
		this.handleClose();
	}
	render() {
		return (
	        <div id={`modal`} className={`modal ${this.props.classes.modal} ${this.props.visible ? 'active' : 'inactive'}`} ref={node => {this.node=node;}}>
	        	<div className={`modalinterior`}>
	        		<div className={`modalcontent`}>
	        			<div className={`modalpage`}>
							{!!this.props.showCloseButton && <div className={`close`} onClick={this.handleClose}><Icon name={`times-circle`} /></div>}
			        		{this.props.content}
			        	</div>
		        	</div>
	        	</div>
	        </div>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Modal);